import { useEffect, useState } from 'react';
import { getSettingsWithLogs, uploadBrandLogo } from '../../../services/adminSettingsService';
import { ImageUrl } from '../../../services/API';
import { updateAuth } from '../../../store/Reducers/authReducer';
import { useReduxStore } from '../../../hooks/useReduxStore';
import { logo } from '../../../assets/Images';

export default function Settings() {
  const {getState,dispatch}=useReduxStore()
  const {settings}=getState("AUTH")
  const [loading, setLoading] = useState(false);
  // const [settings, setSettings] = useState(null);
  const [logs, setLogs] = useState({ data: [], pagination: { total: 0, page: 1, pages: 1, limit: 5 } });
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const fetchData = async (page = 1, limit = 5) => {
    try {
      setLoading(true);
      const resp = await getSettingsWithLogs({ page, limit });
      if (resp?.ok) {
        // setSettings(resp.data?.data?.settings || null);
        setLogs(resp.data?.data?.logs || { data: [], pagination: { total: 0, page: 1, pages: 1, limit } });
        dispatch(updateAuth({ settings: resp.data?.data?.settings || null }));
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const onSaveLogo = async () => {
    if (!file) return;
    try {
      setSaving(true);
      const resp = await uploadBrandLogo(file);
      if (resp?.ok) {
        await fetchData(logs.pagination.page, logs.pagination.limit);
        setFile(null);
      }
    } finally {
      setSaving(false);
    }
  };

  const onPaginate = (nextPage) => {
    if (nextPage < 1 || nextPage > (logs.pagination.pages || 1)) return;
    fetchData(nextPage, logs.pagination.limit);
  };

  return (
    <div className="p-6 space-y-6">
      {/* Branding */}
      <div className="bg-blueGray border-2 border-borderGray rounded-lg p-6">
        <h2 className="text-2xl font-semibold text-white mb-4">Branding</h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-center">
          <div>
            <div className="text-sm text-gray-400 mb-2 p-1">Current Logo</div>
              <img 
              src={settings?.brandLogo?`${ImageUrl}${settings?.brandLogo}`:logo}
               alt="Brand Logo" className="h-32 w-auto border border-borderGray rounded p-2 " />
            
          </div>
          <div className="flex items-center justify-end gap-3">
            <input type="file" accept="image/*" onChange={(e)=>setFile(e.target.files?.[0] || null)} className="text-white" />
            <button onClick={onSaveLogo} disabled={!file || saving} className="px-4 py-2 bg-primaryBlue text-white rounded disabled:opacity-50">
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </div>
      </div>

      {/* System Logs & Audit Trails */}
      <div className="bg-blueGray border-2 border-borderGray rounded-lg p-6">
        <h2 className="text-2xl font-semibold text-white mb-6">System Logs & Audit Trails</h2>
        <div className="overflow-x-auto bg-blueGray border border-borderGray rounded-lg">
          <table className="w-full">
            <thead className="bg-borderGray border-b border-borderGray">
              <tr>
                <th className="px-6 py-5 text-left text-base font-medium text-gray-300 uppercase tracking-wider">Timestamp</th>
                <th className="px-6 py-5 text-left text-base font-medium text-gray-300 uppercase tracking-wider">Level</th>
                <th className="px-6 py-5 text-left text-base font-medium text-gray-300 uppercase tracking-wider">User</th>
                <th className="px-6 py-5 text-left text-base font-medium text-gray-300 uppercase tracking-wider">Action</th>
                <th className="px-6 py-5 text-left text-base font-medium text-gray-300 uppercase tracking-wider">IP Address</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-borderGray">
              {loading ? (
                <tr><td colSpan="5" className="px-6 py-8 text-center text-gray-400">Loading...</td></tr>
              ) : logs.data?.length ? (
                logs.data.map((log) => (
                  <tr key={log._id} className="hover:bg-gray-700/50">
                    <td className="px-6 py-6 text-white whitespace-nowrap">{new Date(log.timestamp || log.createdAt).toLocaleString()}</td>
                    <td className="px-6 py-6 text-white whitespace-nowrap capitalize">{log.level}</td>
                    <td className="px-6 py-6 text-white whitespace-nowrap">{log.user?.email || '-'}</td>
                    <td className="px-6 py-6 text-white whitespace-nowrap">{log.action}</td>
                    <td className="px-6 py-6 text-white whitespace-nowrap">{log.ipAddress || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="5" className="px-6 py-8 text-center text-gray-400">No logs found</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {logs.pagination?.pages > 1 && (
          <div className="flex items-center justify-between mt-4">
            <div className="text-sm text-gray-400">Page {logs.pagination.page} of {logs.pagination.pages} ({logs.pagination.total} total)</div>
            <div className="flex gap-2">
              <button disabled={logs.pagination.page===1} onClick={()=>onPaginate(logs.pagination.page-1)} className="px-3 py-2 bg-gray-700 text-white rounded disabled:opacity-50">Prev</button>
              <button disabled={logs.pagination.page===logs.pagination.pages} onClick={()=>onPaginate(logs.pagination.page+1)} className="px-3 py-2 bg-gray-700 text-white rounded disabled:opacity-50">Next</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


